<style scoped lang="less">
.newGoods{
  // height: 300px;
  display: flex;
  position: relative;
  &_statics{
    position: absolute;
    bottom: 30px;
    right: 20px;
  }

}
</style>
<script>
import methods from './methods.js'
import Container from "modules/shop/_id/components/container/index.vue";
import Chart from './components/chart/index.vue'
import Statics from './components/statics'
export default {
  name: "newGoods",
  components: { Container,Chart,Statics },
  mixins: [methods]
}
</script>
<template>
  <Container icon="https://s6.bihukankan.com/img/1695710281.svg" title="新品分析">
    <div class="newGoods">
      <Chart :data="chartDataApi"/>
      <Statics :data="chartDataApi" class="newGoods_statics"/>
    </div>
  </Container>
</template>

